import Swiper from "swiper";
import 'swiper/swiper.css';

(async function () {
    const sliderElements = document.querySelectorAll('[data-camao-slider]');

    sliderElements.forEach(async (slider) => {
        let modules = [];
        let settings = {};
        if (slider.dataset.loop === 'true') {
            settings.loop = slider.dataset.loop === 'true';
        }
        if (slider.dataset.autoplay === 'true') {
            const {Autoplay} = await import('swiper/modules');
            modules.push(Autoplay);
            settings.autoplay = {
                delay: parseInt(slider.dataset.interval) * 1000 ?? 3000
            }
        }
        if (slider.dataset.transition) {
            settings.speed = parseInt(slider.dataset.transition) ?? 300
        }
        if (slider.dataset.slidesPerView) {
            settings.slidesPerView = parseFloat(slider.dataset.slidesPerView);
        }
        if (slider.querySelector('[data-camao-slider-navigation]')) {
            let {Navigation} = await import('swiper/modules');
            await import('swiper/modules/navigation.css');
            modules.push(Navigation);
            settings.navigation = {
                nextEl: slider.querySelector('[data-camao-slider-navigation-next]'),
                prevEl: slider.querySelector('[data-camao-slider-navigation-prev]')
            };
        }
        if (slider.querySelector('[data-camao-slider-pagination]')) {
            let {Pagination} = await import('swiper/modules');
            await import('swiper/modules/pagination.css');
            modules.push(Pagination);
            settings.pagination = {
                el: slider.querySelector('[data-camao-slider-pagination]'),
                type: slider.dataset.pagination ?? 'bullets'
            };
        }
        settings.modules = modules;
        const swiper = new Swiper('[data-camao-slider]', settings);
    });
})();
